export default __webpack_public_path__ + "static/media/mazar2.dbcb2d42.jpg";